
  <div class="filter-container">
    <form [formGroup]="newestForm" (ngSubmit)="apply()">
      <div class="title">
        <span id="icon" class="material-icons-outlined">new_releases</span>
        <label for="top">Top</label>
      </div>
      <input id="top" type="number" formControlName="top" />
      <button class="apply-filter-btn" type="submit">Apply</button>
    </form>
  </div>

